module.exports = __webpack_public_path__ + "757cdf12eb81d5318d6234b788237982.svg";